import { Fragment } from "react";
import { NavLink } from "react-router-dom";

import { ProductType } from "@src/types/ProductType";
import { offerLink } from "@src/utils/offerLink";

type Props = {
  product: ProductType;
  minimized?: boolean;
};

const ProductsListItem = ({ product, minimized = false }: Props) => {
  const imageUrl = product.featuredImage
    ? import.meta.env.VITE_MARKETPLACE_API_URL + "/asset/" + product.featuredImage
    : "/images/placeholder/marketplace-item.png";

  return (
    <div className="text-sm transition delay-150 ease-in-out">
      <NavLink to={`/marketplace/offers${offerLink(product.title, Number(product.id))}`}>
        <div className="group/contextmenu relative flex aspect-square items-center justify-center overflow-hidden">
          <img alt="" src={imageUrl} />
        </div>
        {!minimized && (
          <Fragment>
            <div className="mt-5 line-clamp-1 h-[20px] overflow-x-hidden text-ellipsis font-bold">
              {product.title}
            </div>
            <div className="line-clamp-1 h-[25px] overflow-x-hidden text-ellipsis text-xl font-bold">
              {product.price.viewPattern.replace(
                "{VALUE}",
                new Intl.NumberFormat("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(product.price.value / 1000),
              )}
            </div>
          </Fragment>
        )}
      </NavLink>
    </div>
  );
};

export default ProductsListItem;
